"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const AssociateProductTitle_1 = __importDefault(require("@/pages/Products/components/AssociateProductTitle"));
const EditProductsAssocationTable_1 = __importDefault(require("../EditProductsAssocationTable"));
const style_1 = require("./style");
function EditProductAssociationSectionView({ areAssociatedComponentsLoading, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true, style: { height: "100%" } }, areAssociatedComponentsLoading ? (react_1.default.createElement(style_1.TitleLoader, { variant: "rectangular" })) : (react_1.default.createElement(AssociateProductTitle_1.default, null))),
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true }, areAssociatedComponentsLoading ? (react_1.default.createElement(style_1.TableLoader, { variant: "rectangular" })) : (react_1.default.createElement(EditProductsAssocationTable_1.default, null)))));
}
exports.default = EditProductAssociationSectionView;
